import { TextField } from '@material-ui/core';
import * as React from 'react';

interface IProps {
  onSubmit: (value: string) => void;
}

class Search extends React.Component<IProps, any> {
  public state = {
    value: '',
  };

  public onInputChange() {
    return (event: React.ChangeEvent<HTMLInputElement>) => {
      this.setState({ value: event.target.value });
    };
  }

  public onSearch() {
    return (event: React.KeyboardEvent<HTMLDivElement>) => {
      if (event.keyCode === 13) {
        this.props.onSubmit(this.state.value);
      }
    };
  }

  public render() {
    return (
      <TextField
        id="search"
        label="Search"
        type="search"
        margin="normal"
        onChange={this.onInputChange()}
        onKeyUp={this.onSearch()}
      />
    );
  }
}

export default Search;



// WEBPACK FOOTER //
// ./src/components/Search/Search.tsx